import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';

const ReadXmlForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="readXmlFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="readXmlFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="readXmlFormInferSchema"
        label="inferSchema"
        name="properties.inferSchema"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="readXmlFormMode"
        label="mode"
        name="properties.mode"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter mode"
        error={errors.properties?.mode?.message}
      />
      <FormField
        controlId="readXmlFormColumnNameOfCorruptRecord"
        label="columnNameOfCorruptRecord"
        name="properties.columnNameOfCorruptRecord"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter column name of corrupt record"
        error={errors.properties?.columnNameOfCorruptRecord?.message}
      />
      <FormField
        controlId="readXmlFormRowTag"
        label="rowTag"
        name="properties.rowTag"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter row tag"
        error={errors.properties?.rowTag?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default ReadXmlForm;
